import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { recordActions, getRecordEntities } from "data/recordApi"
import WithObject from "./WithObject"

class WithRecord extends React.Component {
    render() {
        const recordsData = this.props.records
        if (!recordsData) return this.props.loading ? this.props.loading : ""
        const record = recordsData[this.props.recordId]
        if (!record) return this.props.loading ? this.props.loading : ""
        return (
            <WithObject objectId={record._object_id}>
                {({ object, primaryField }) =>
                    this.props.children({
                        object,
                        primaryField,
                        record,
                        onChange: value => this.props.recordActions.update(record._sid, value),
                    })
                }
            </WithObject>
        )
    }

    constructor(props) {
        super(props)
        props.recordActions.fetch(this.props.recordId)
    }

    componentWillReceiveProps(newProps) {
        if (newProps.recordId !== this.props.recordId)
            newProps.recordActions.fetch(newProps.recordId)
    }
}

WithRecord.propTypes = {
    recordId: PropTypes.string,
}

function mapStateToProps(state) {
    return {
        records: getRecordEntities(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        recordActions: bindActionCreators(recordActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRecord)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithRecord.js